/* ss-product-bundles.js — SeatShield product page bundle tier picker (vanilla JS)
   Adapted from MudGear mg-product-bundles.js. Namespace mg- → ss-. */

(function () {
  'use strict';

  function init() {
    var bundles = document.querySelectorAll('[data-ss-bundles]');
    if (!bundles.length) return;

    bundles.forEach(setupBundle);

    // Impulse fires `variant:change` with evt.detail.variant on option change
    document.addEventListener('variant:change', handleVariantChange);
  }

  function setupBundle(bundleEl) {
    var tiersContainer = bundleEl.querySelector('[data-ss-bundle-tiers]');
    if (!tiersContainer) return;

    var productForm = findProductForm(bundleEl);
    if (!productForm) {
      console.warn('[ss-product-bundles] No /cart/add product form found near bundle section');
      return;
    }

    tiersContainer.addEventListener('click', function (e) {
      var tierCard = e.target.closest('[data-tier-index]');
      if (!tierCard) return;
      if (tierCard.classList.contains('ss-product-bundles__tier--disabled')) {
        e.preventDefault();
        return;
      }
      selectTier(tiersContainer, tierCard, productForm);
    });

    // Arrow-key navigation within the radiogroup
    tiersContainer.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft' && e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
      var cards = Array.from(tiersContainer.querySelectorAll('[data-tier-index]:not(.ss-product-bundles__tier--disabled)'));
      if (!cards.length) return;
      var current = tiersContainer.querySelector('.ss-product-bundles__tier--selected');
      var currentIdx = cards.indexOf(current);
      var delta = (e.key === 'ArrowRight' || e.key === 'ArrowDown') ? 1 : -1;
      var nextIdx = (currentIdx + delta + cards.length) % cards.length;
      selectTier(tiersContainer, cards[nextIdx], productForm);
      cards[nextIdx].focus();
      e.preventDefault();
    });

    var defaultTier = tiersContainer.querySelector('.ss-product-bundles__tier--selected');
    if (defaultTier) {
      updateFormQuantity(productForm, defaultTier.dataset.tierQuantity);
    }
  }

  function selectTier(tiersContainer, tierCard, productForm) {
    tiersContainer.querySelectorAll('[data-tier-index]').forEach(function (el) {
      el.classList.remove('ss-product-bundles__tier--selected');
      el.setAttribute('aria-checked', 'false');
    });
    tierCard.classList.add('ss-product-bundles__tier--selected');
    tierCard.setAttribute('aria-checked', 'true');

    var radio = tierCard.querySelector('.ss-product-bundles__tier-radio');
    if (radio) radio.checked = true;

    updateFormQuantity(productForm, tierCard.dataset.tierQuantity);
  }

  function findProductForm(bundleEl) {
    var form = bundleEl.closest('form[action*="/cart/add"]');
    if (form) return form;
    return document.querySelector('form[action*="/cart/add"]');
  }

  function updateFormQuantity(form, qty) {
    if (!form || !qty) return;
    var qtyInput = form.querySelector('input[name="quantity"]');
    if (!qtyInput) {
      qtyInput = document.createElement('input');
      qtyInput.type = 'hidden';
      qtyInput.name = 'quantity';
      form.appendChild(qtyInput);
    }
    qtyInput.value = qty;
  }

  function handleVariantChange(evt) {
    var variant = evt && evt.detail && evt.detail.variant;
    if (!variant) return;

    document.querySelectorAll('[data-ss-bundles]').forEach(function (bundleEl) {
      bundleEl.querySelectorAll('[data-tier-index]').forEach(function (tierCard) {
        var pct = parseFloat(tierCard.dataset.tierDiscountPct) || 0;
        var newPriceCents = variant.price * (1 - pct / 100);
        var displayEl = tierCard.querySelector('[data-display-price]');
        if (displayEl) {
          var suffixEl = displayEl.querySelector('[data-price-suffix]');
          var suffixText = suffixEl ? suffixEl.outerHTML : '';
          displayEl.innerHTML = formatMoney(newPriceCents) + suffixText;
        }

        if (variant.available) {
          tierCard.classList.remove('ss-product-bundles__tier--disabled');
          tierCard.removeAttribute('aria-disabled');
          var radio = tierCard.querySelector('.ss-product-bundles__tier-radio');
          if (radio) radio.disabled = false;
        } else {
          tierCard.classList.add('ss-product-bundles__tier--disabled');
          tierCard.setAttribute('aria-disabled', 'true');
          var radio2 = tierCard.querySelector('.ss-product-bundles__tier-radio');
          if (radio2) radio2.disabled = true;
        }
      });
    });
  }

  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      var format = (window.theme && window.theme.settings && window.theme.settings.moneyFormat) || '${{amount}}';
      return window.Shopify.formatMoney(cents, format);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
